import { render, staticRenderFns } from "./PageLinks.vue?vue&type=template&id=ab60ddd4&"
import script from "./PageLinks.vue?vue&type=script&lang=js&"
export * from "./PageLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageLink: require('/vercel/path0/components/cards/PageLink.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
